/**
 * Imperative feedback API (works outside React components once FeedbackProvider mounts).
 */

let controller = null;

export function registerFeedbackController(c) {
  controller = c;
}

export function showAlert(message, options = {}) {
  const text =
    typeof message === "string"
      ? message
      : message != null
        ? String(message)
        : "Something went wrong.";
  if (controller?.alert) {
    controller.alert(text, options);
    return;
  }
  console.warn("[feedback]", text);
}

export function showConfirm(message, options = {}) {
  const text =
    typeof message === "string"
      ? message
      : message != null
        ? String(message)
        : "";
  if (controller?.confirm) {
    return controller.confirm(text, options);
  }
  console.warn("[feedback] confirm (no provider):", text);
  return Promise.resolve(false);
}

export function setGlobalLoading(visible, message = "") {
  if (controller?.setLoading) {
    controller.setLoading(Boolean(visible), message);
  }
}
